import { render, staticRenderFns } from "./add-marque.vue?vue&type=template&id=50addcb2"
import script from "./add-marque.vue?vue&type=script&lang=js"
export * from "./add-marque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports